module.exports = __webpack_public_path__ + "img/middle.fc25b601.png";